module.exports = __webpack_public_path__ + "img/SEJ_Eventos_me interesa.3a74202d.svg";